export default __webpack_public_path__ + "static/media/alert-circle.1c363133.svg";